(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabecera-saint-clement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var claseDesplazada = 'esta-desplazada';
    var claseOculta = 'esta-oculta';
    var claseAbierto = 'panel-abierto';
    var claseBloqueo = 'cabecera-sc-bloqueado';

    function iniciarCabecera(raiz) {
      if (!raiz || raiz.dataset.cabeceraLista === 'true') return;
      raiz.dataset.cabeceraLista = 'true';

      var umbral = parseInt(raiz.dataset.umbral, 10);
      if (isNaN(umbral)) umbral = 60;
      var permiteOcultar = raiz.dataset.ocultar === 'true';

      var alternador = raiz.querySelector('[data-alternador]');
      var panel = raiz.querySelector('[data-panel]');
      var espaciador = raiz.parentNode ? raiz.parentNode.querySelector('[data-espaciador]') : null;
      var enlacesPanel = panel ? panel.querySelectorAll('[data-cierra-panel]') : [];

      var ultimoDesplazamiento = window.pageYOffset || 0;
      var pendiente = false;
      var abierto = false;

      function medirAltura() {
        var altura = raiz.offsetHeight;
        raiz.style.setProperty('--cab-sc-altura', altura + 'px');
        document.documentElement.style.setProperty('--altura-cabecera-sc', altura + 'px');
        if (espaciador) espaciador.style.height = altura + 'px';
      }

      function evaluar() {
        var actual = window.pageYOffset || 0;

        if (actual > umbral) {
          raiz.classList.add(claseDesplazada);
        } else {
          raiz.classList.remove(claseDesplazada);
        }

        if (permiteOcultar && !abierto) {
          if (actual > ultimoDesplazamiento && actual > umbral + 80) {
            raiz.classList.add(claseOculta);
          } else {
            raiz.classList.remove(claseOculta);
          }
        }

        ultimoDesplazamiento = actual < 0 ? 0 : actual;
        pendiente = false;
      }

      function alDesplazar() {
        if (pendiente) return;
        pendiente = true;
        window.requestAnimationFrame(evaluar);
      }

      function abrirPanel() {
        if (!panel) return;
        abierto = true;
        panel.removeAttribute('hidden');
        raiz.classList.add(claseAbierto);
        raiz.classList.remove(claseOculta);
        document.documentElement.classList.add(claseBloqueo);
        if (alternador) alternador.setAttribute('aria-expanded', 'true');
      }

      function cerrarPanel() {
        if (!panel) return;
        abierto = false;
        raiz.classList.remove(claseAbierto);
        document.documentElement.classList.remove(claseBloqueo);
        if (alternador) alternador.setAttribute('aria-expanded', 'false');
        window.setTimeout(function () {
          if (!abierto) panel.setAttribute('hidden', '');
        }, 700);
      }

      function alternarPanel() {
        if (abierto) {
          cerrarPanel();
        } else {
          abrirPanel();
        }
      }

      if (alternador) {
        alternador.addEventListener('click', alternarPanel);
      }

      for (var i = 0; i < enlacesPanel.length; i++) {
        enlacesPanel[i].addEventListener('click', cerrarPanel);
      }

      document.addEventListener('keydown', function (evento) {
        if (evento.key === 'Escape' && abierto) {
          cerrarPanel();
          if (alternador) alternador.focus();
        }
      });

      window.addEventListener('scroll', alDesplazar, { passive: true });
      window.addEventListener('resize', function () {
        medirAltura();
        if (window.innerWidth >= 990 && abierto) cerrarPanel();
      });

      if (window.matchMedia) {
        var consulta = window.matchMedia('(min-width: 990px)');
        if (consulta.addEventListener) {
          consulta.addEventListener('change', function (evento) {
            if (evento.matches && abierto) cerrarPanel();
          });
        }
      }

      medirAltura();
      evaluar();
      window.setTimeout(medirAltura, 400);

      raiz.cerrarPanelSaintClement = cerrarPanel;
    }

    function iniciarTodas(contexto) {
      var ambito = contexto || document;
      var cabeceras = ambito.querySelectorAll('[data-cabecera-sc]');
      for (var i = 0; i < cabeceras.length; i++) {
        iniciarCabecera(cabeceras[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        iniciarTodas();
      });
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      iniciarTodas(evento.target);
    });

    document.addEventListener('shopify:section:unload', function () {
      document.documentElement.classList.remove(claseBloqueo);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["declaracion-saint-clement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarDeclaracion(raiz) {
      if (!raiz || raiz.dataset.declaracionLista === 'true') return;
      raiz.dataset.declaracionLista = 'true';

      if (raiz.classList.contains('esta-revelada')) return;

      function revelar() {
        raiz.classList.add('esta-revelada');
      }

      if ('IntersectionObserver' in window) {
        var observador = new IntersectionObserver(function (entradas) {
          for (var i = 0; i < entradas.length; i++) {
            if (entradas[i].isIntersecting) {
              revelar();
              observador.disconnect();
            }
          }
        }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
        observador.observe(raiz);
      } else {
        revelar();
      }
    }

    function iniciarTodas(contexto) {
      var ambito = contexto || document;
      var secciones = ambito.querySelectorAll('[data-declaracion-sc]');
      for (var i = 0; i < secciones.length; i++) {
        iniciarDeclaracion(secciones[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        iniciarTodas();
      });
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      iniciarTodas(evento.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["esmeralda-relato"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;

    function formatear(valor, decimales) {
      var partes = valor.toFixed(decimales).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return partes.join('.');
    }

    function configurarAcordeon(raiz) {
      var pasos = raiz.querySelectorAll('.esmeralda-relato__paso');

      Array.prototype.forEach.call(pasos, function (paso) {
        var cabecera = paso.querySelector('.esmeralda-relato__paso-cabecera');
        var cuerpo = paso.querySelector('.esmeralda-relato__paso-cuerpo');
        if (!cabecera || !cuerpo) {
          return;
        }

        var abierto = paso.classList.contains('esmeralda-relato__paso--activo');
        cabecera.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        cuerpo.style.maxHeight = abierto ? cuerpo.scrollHeight + 'px' : '0px';

        cabecera.addEventListener('click', function () {
          var estaAbierto = paso.classList.contains('esmeralda-relato__paso--activo');

          Array.prototype.forEach.call(pasos, function (otro) {
            var otroCuerpo = otro.querySelector('.esmeralda-relato__paso-cuerpo');
            var otraCabecera = otro.querySelector('.esmeralda-relato__paso-cabecera');
            otro.classList.remove('esmeralda-relato__paso--activo');
            if (otraCabecera) {
              otraCabecera.setAttribute('aria-expanded', 'false');
            }
            if (otroCuerpo) {
              otroCuerpo.style.maxHeight = otroCuerpo.scrollHeight + 'px';
              void otroCuerpo.offsetHeight;
              otroCuerpo.style.maxHeight = '0px';
            }
          });

          if (!estaAbierto) {
            paso.classList.add('esmeralda-relato__paso--activo');
            cabecera.setAttribute('aria-expanded', 'true');
            cuerpo.style.maxHeight = cuerpo.scrollHeight + 'px';
          }
        });
      });

      window.addEventListener('resize', function () {
        var activo = raiz.querySelector('.esmeralda-relato__paso--activo .esmeralda-relato__paso-cuerpo');
        if (activo) {
          activo.style.maxHeight = activo.scrollHeight + 'px';
        }
      });
    }

    function animarContadores(raiz) {
      var valores = raiz.querySelectorAll('.esmeralda-relato__stat-valor');

      Array.prototype.forEach.call(valores, function (el) {
        var objetivo = parseFloat(el.getAttribute('data-valor'));
        if (isNaN(objetivo)) {
          return;
        }
        var numero = el.querySelector('.esmeralda-relato__stat-numero');
        if (!numero) {
          return;
        }
        var decimales = parseInt(el.getAttribute('data-decimales'), 10) || 0;
        var duracion = 1600;
        var inicio = null;

        function paso(tiempo) {
          if (!inicio) {
            inicio = tiempo;
          }
          var avance = Math.min((tiempo - inicio) / duracion, 1);
          var suavizado = 1 - Math.pow(1 - avance, 3);
          numero.textContent = formatear(objetivo * suavizado, decimales);
          if (avance < 1) {
            requestAnimationFrame(paso);
          } else {
            numero.textContent = formatear(objetivo, decimales);
          }
        }

        requestAnimationFrame(paso);
      });
    }

    function iniciar(raiz) {
      if (raiz.getAttribute('data-iniciado') === '1') {
        return;
      }
      raiz.setAttribute('data-iniciado', '1');

      configurarAcordeon(raiz);

      var animaciones = raiz.getAttribute('data-animaciones') === '1';

      if (!animaciones || reduce) {
        if (animaciones) {
          raiz.classList.add('esmeralda-relato--enescena');
        }
        return;
      }

      Array.prototype.forEach.call(raiz.querySelectorAll('.esmeralda-relato__stat-valor'), function (el) {
        if (!isNaN(parseFloat(el.getAttribute('data-valor')))) {
          var numero = el.querySelector('.esmeralda-relato__stat-numero');
          if (numero) {
            numero.textContent = '0';
          }
        }
      });

      if (!('IntersectionObserver' in window)) {
        raiz.classList.add('esmeralda-relato--enescena');
        animarContadores(raiz);
        return;
      }

      var observador = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) {
              raiz.classList.add('esmeralda-relato--enescena');
              animarContadores(raiz);
              observador.unobserve(raiz);
            }
          });
        },
        { threshold: 0.2 }
      );

      observador.observe(raiz);
    }

    function init() {
      var bloques = document.querySelectorAll('.esmeralda-relato');
      Array.prototype.forEach.call(bloques, iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-saintclement"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(seccion) {
    var cabecera = seccion.querySelector('.sc-cabecera');
    var espaciador = seccion.querySelector('[data-sc-espaciador]');
    var umbral = parseInt(seccion.getAttribute('data-sc-umbral') || '40', 10);
    var reservar = seccion.getAttribute('data-sc-reservar') === 'true';
    var fija = false;

    function ajustarEspaciador() {
      if (reservar && espaciador) {
        espaciador.style.height = cabecera.offsetHeight + 'px';
      }
    }

    function alScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (y > umbral && !fija) {
        fija = true;
        cabecera.classList.add('sc-cabecera--fija');
      } else if (y <= umbral && fija) {
        fija = false;
        cabecera.classList.remove('sc-cabecera--fija');
      }
    }

    ajustarEspaciador();
    alScroll();
    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', ajustarEspaciador);
    window.addEventListener('load', ajustarEspaciador);

    var boton = seccion.querySelector('.sc-menu-boton');
    var cerrar = seccion.querySelector('.sc-drawer__cerrar');
    var overlay = seccion.querySelector('[data-sc-overlay]');
    var drawer = seccion.querySelector('[data-sc-drawer]');

    function abrirDrawer() {
      if (!drawer) return;
      drawer.classList.add('sc-drawer--abierto');
      if (overlay) overlay.classList.add('sc-drawer__overlay--visible');
      drawer.setAttribute('aria-hidden', 'false');
      if (boton) boton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function cerrarDrawer() {
      if (!drawer) return;
      drawer.classList.remove('sc-drawer--abierto');
      if (overlay) overlay.classList.remove('sc-drawer__overlay--visible');
      drawer.setAttribute('aria-hidden', 'true');
      if (boton) boton.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (boton) boton.addEventListener('click', abrirDrawer);
    if (cerrar) cerrar.addEventListener('click', cerrarDrawer);
    if (overlay) overlay.addEventListener('click', cerrarDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cerrarDrawer();
    });

    var enlacesDrawer = seccion.querySelectorAll('.sc-drawer__item');
    enlacesDrawer.forEach(function (enlace) {
      enlace.addEventListener('click', cerrarDrawer);
    });
  }

  function arrancar() {
    document.querySelectorAll('[data-sc-header]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-saint-clement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarHeroe(raiz) {
      if (!raiz || raiz.dataset.heroeListo === 'true') return;
      raiz.dataset.heroeListo = 'true';

      var indicador = raiz.querySelector('[data-indicador]');

      function revelar() {
        raiz.classList.add('esta-revelado');
      }

      if ('IntersectionObserver' in window) {
        var observador = new IntersectionObserver(function (entradas) {
          for (var i = 0; i < entradas.length; i++) {
            if (entradas[i].isIntersecting) {
              revelar();
              observador.disconnect();
            }
          }
        }, { threshold: 0.15 });
        observador.observe(raiz);
      } else {
        revelar();
      }

      window.requestAnimationFrame(function () {
        window.setTimeout(revelar, 80);
      });

      if (indicador) {
        var pendiente = false;

        function evaluar() {
          if ((window.pageYOffset || 0) > 40) {
            raiz.classList.add('esta-desplazado');
          } else {
            raiz.classList.remove('esta-desplazado');
          }
          pendiente = false;
        }

        window.addEventListener('scroll', function () {
          if (pendiente) return;
          pendiente = true;
          window.requestAnimationFrame(evaluar);
        }, { passive: true });

        evaluar();
      }
    }

    function iniciarTodos(contexto) {
      var ambito = contexto || document;
      var heroes = ambito.querySelectorAll('[data-heroe-sc]');
      for (var i = 0; i < heroes.length; i++) {
        iniciarHeroe(heroes[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        iniciarTodos();
      });
    } else {
      iniciarTodos();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      iniciarTodos(evento.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-saint-clement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarResenas(raiz) {
      if (!raiz || raiz.dataset.resenasLista === 'true') return;
      raiz.dataset.resenasLista = 'true';

      var pista = raiz.querySelector('[data-pista]');
      var laminas = Array.prototype.slice.call(raiz.querySelectorAll('[data-lamina]'));
      var segmentos = Array.prototype.slice.call(raiz.querySelectorAll('[data-segmento]'));
      var anterior = raiz.querySelector('[data-anterior]');
      var siguiente = raiz.querySelector('[data-siguiente]');

      var total = laminas.length;
      if (!pista || total === 0) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var permiteAutoplay = raiz.dataset.autoplay === 'true' && !reduce && total > 1;
      var duracion = parseInt(raiz.dataset.duracion, 10) || 7000;

      var actual = 0;
      var temporizador = null;
      var pausado = false;
      var pendiente = false;

      function irA(indice, suave) {
        var destino = ((indice % total) + total) % total;
        pista.scrollTo({
          left: laminas[destino].offsetLeft - pista.offsetLeft,
          behavior: suave === false ? 'auto' : 'smooth'
        });
      }

      function marcar(indice) {
        actual = indice;
        for (var i = 0; i < segmentos.length; i++) {
          var esActual = i === indice;
          segmentos[i].classList.toggle('esta-activo', esActual);
          segmentos[i].setAttribute('aria-selected', esActual ? 'true' : 'false');
          segmentos[i].setAttribute('tabindex', esActual ? '0' : '-1');
        }
        if (anterior) anterior.disabled = false;
        if (siguiente) siguiente.disabled = false;
      }

      function calcular() {
        var centro = pista.scrollLeft + pista.clientWidth / 2;
        var mejor = 0;
        var minimo = Infinity;
        for (var i = 0; i < laminas.length; i++) {
          var medio = laminas[i].offsetLeft - pista.offsetLeft + laminas[i].offsetWidth / 2;
          var distancia = Math.abs(medio - centro);
          if (distancia < minimo) {
            minimo = distancia;
            mejor = i;
          }
        }
        if (mejor !== actual) marcar(mejor);
        pendiente = false;
      }

      pista.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        window.requestAnimationFrame(calcular);
      }, { passive: true });

      function programar() {
        window.clearTimeout(temporizador);
        if (!permiteAutoplay || pausado) return;
        temporizador = window.setTimeout(function () {
          irA(actual + 1);
          programar();
        }, duracion);
      }

      function detener() {
        pausado = true;
        window.clearTimeout(temporizador);
      }

      function reanudar() {
        pausado = false;
        programar();
      }

      if (anterior) {
        anterior.addEventListener('click', function () {
          detener();
          irA(actual - 1);
        });
      }

      if (siguiente) {
        siguiente.addEventListener('click', function () {
          detener();
          irA(actual + 1);
        });
      }

      for (var s = 0; s < segmentos.length; s++) {
        (function (segmento, indice) {
          segmento.addEventListener('click', function () {
            detener();
            irA(indice);
          });

          segmento.addEventListener('keydown', function (evento) {
            if (evento.key !== 'ArrowLeft' && evento.key !== 'ArrowRight') return;
            evento.preventDefault();
            var destino = evento.key === 'ArrowRight' ? indice + 1 : indice - 1;
            if (destino < 0) destino = total - 1;
            if (destino >= total) destino = 0;
            detener();
            irA(destino);
            segmentos[destino].focus();
          });
        })(segmentos[s], s);
      }

      pista.addEventListener('keydown', function (evento) {
        if (evento.key === 'ArrowLeft') {
          evento.preventDefault();
          detener();
          irA(actual - 1);
        }
        if (evento.key === 'ArrowRight') {
          evento.preventDefault();
          detener();
          irA(actual + 1);
        }
      });

      raiz.addEventListener('mouseenter', detener);
      raiz.addEventListener('mouseleave', reanudar);
      raiz.addEventListener('focusin', detener);
      pista.addEventListener('touchstart', detener, { passive: true });

      window.addEventListener('resize', function () {
        window.clearTimeout(temporizador);
        irA(actual, false);
        programar();
      });

      marcar(0);

      if ('IntersectionObserver' in window) {
        var arranque = new IntersectionObserver(function (entradas) {
          for (var a = 0; a < entradas.length; a++) {
            if (entradas[a].isIntersecting) {
              programar();
              arranque.disconnect();
            }
          }
        }, { threshold: 0.3 });
        arranque.observe(raiz);
      } else {
        programar();
      }
    }

    function iniciarTodas(contexto) {
      var ambito = contexto || document;
      var secciones = ambito.querySelectorAll('[data-resenas-sc]');
      for (var i = 0; i < secciones.length; i++) {
        iniciarResenas(secciones[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        iniciarTodas();
      });
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      iniciarTodas(evento.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-vitrina"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;

    function formatear(valor, decimales) {
      return valor.toFixed(decimales);
    }

    function configurarCarrusel(raiz) {
      var carrusel = raiz.querySelector('[data-carrusel]');
      if (!carrusel) {
        return;
      }
      var pista = carrusel.querySelector('.resenas-vitrina__pista');
      var slides = carrusel.querySelectorAll('.resenas-vitrina__slide');
      if (!pista || slides.length <= 1) {
        return;
      }

      var dots = carrusel.querySelectorAll('.resenas-vitrina__dot');
      var prev = carrusel.querySelector('.resenas-vitrina__flecha--prev');
      var next = carrusel.querySelector('.resenas-vitrina__flecha--next');
      var total = slides.length;
      var indice = 0;
      var temporizador = null;
      var autoplay = raiz.getAttribute('data-autoplay') === '1' && !reduce;
      var velocidad = parseInt(raiz.getAttribute('data-velocidad'), 10) || 5000;

      function pintar() {
        pista.style.setProperty('--indice', indice);
        Array.prototype.forEach.call(dots, function (dot, i) {
          if (i === indice) {
            dot.classList.add('resenas-vitrina__dot--activo');
          } else {
            dot.classList.remove('resenas-vitrina__dot--activo');
          }
        });
      }

      function ir(nuevo) {
        indice = (nuevo + total) % total;
        pintar();
      }

      function reiniciar() {
        if (!autoplay) {
          return;
        }
        if (temporizador) {
          clearInterval(temporizador);
        }
        temporizador = setInterval(function () {
          ir(indice + 1);
        }, velocidad);
      }

      if (next) {
        next.addEventListener('click', function () {
          ir(indice + 1);
          reiniciar();
        });
      }
      if (prev) {
        prev.addEventListener('click', function () {
          ir(indice - 1);
          reiniciar();
        });
      }

      Array.prototype.forEach.call(dots, function (dot, i) {
        dot.addEventListener('click', function () {
          ir(i);
          reiniciar();
        });
      });

      var inicioX = null;
      carrusel.addEventListener('touchstart', function (e) {
        inicioX = e.touches[0].clientX;
      }, { passive: true });
      carrusel.addEventListener('touchend', function (e) {
        if (inicioX === null) {
          return;
        }
        var delta = e.changedTouches[0].clientX - inicioX;
        if (Math.abs(delta) > 40) {
          ir(delta < 0 ? indice + 1 : indice - 1);
          reiniciar();
        }
        inicioX = null;
      }, { passive: true });

      carrusel.addEventListener('mouseenter', function () {
        if (temporizador) {
          clearInterval(temporizador);
        }
      });
      carrusel.addEventListener('mouseleave', reiniciar);

      pintar();
      reiniciar();
    }

    function animarNota(raiz) {
      var el = raiz.querySelector('.resenas-vitrina__nota');
      if (!el) {
        return;
      }
      var objetivo = parseFloat(el.getAttribute('data-valor'));
      if (isNaN(objetivo)) {
        return;
      }
      var decimales = parseInt(el.getAttribute('data-decimales'), 10);
      if (isNaN(decimales)) {
        decimales = 1;
      }
      var duracion = 1400;
      var inicio = null;

      function paso(tiempo) {
        if (!inicio) {
          inicio = tiempo;
        }
        var avance = Math.min((tiempo - inicio) / duracion, 1);
        var suavizado = 1 - Math.pow(1 - avance, 3);
        el.textContent = formatear(objetivo * suavizado, decimales);
        if (avance < 1) {
          requestAnimationFrame(paso);
        } else {
          el.textContent = formatear(objetivo, decimales);
        }
      }

      requestAnimationFrame(paso);
    }

    function iniciar(raiz) {
      if (raiz.getAttribute('data-iniciado') === '1') {
        return;
      }
      raiz.setAttribute('data-iniciado', '1');

      configurarCarrusel(raiz);

      var animaciones = raiz.getAttribute('data-animaciones') === '1';

      if (!animaciones || reduce) {
        if (animaciones) {
          raiz.classList.add('resenas-vitrina--enescena');
        }
        return;
      }

      var nota = raiz.querySelector('.resenas-vitrina__nota');
      if (nota && !isNaN(parseFloat(nota.getAttribute('data-valor')))) {
        nota.textContent = '0';
      }

      if (!('IntersectionObserver' in window)) {
        raiz.classList.add('resenas-vitrina--enescena');
        animarNota(raiz);
        return;
      }

      var observador = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) {
              raiz.classList.add('resenas-vitrina--enescena');
              animarNota(raiz);
              observador.unobserve(raiz);
            }
          });
        },
        { threshold: 0.25 }
      );

      observador.observe(raiz);
    }

    function init() {
      var bloques = document.querySelectorAll('.resenas-vitrina');
      Array.prototype.forEach.call(bloques, iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viaje-saint-clement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarViaje(raiz) {
      if (!raiz || raiz.dataset.viajeListo === 'true') return;
      raiz.dataset.viajeListo = 'true';

      var escenario = raiz.querySelector('[data-escenario]');
      var laminas = Array.prototype.slice.call(raiz.querySelectorAll('[data-lamina]'));
      var rotulos = Array.prototype.slice.call(raiz.querySelectorAll('[data-rotulo]'));
      var paradas = Array.prototype.slice.call(raiz.querySelectorAll('[data-parada]'));
      var relleno = raiz.querySelector('[data-relleno]');
      var contador = raiz.querySelector('[data-contador]');

      var total = laminas.length;
      if (!escenario || total === 0) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var permiteAutoplay = raiz.dataset.autoplay === 'true' && !reduce;
      var duracion = parseInt(raiz.dataset.duracion, 10) || 6000;

      var actual = 0;
      var temporizador = null;
      var pausado = false;
      var arrancado = false;

      function programar() {
        window.clearTimeout(temporizador);
        if (!permiteAutoplay || pausado || total < 2) return;
        temporizador = window.setTimeout(function () {
          mostrar(actual + 1);
        }, duracion);
      }

      function mostrar(indice) {
        actual = ((indice % total) + total) % total;

        for (var i = 0; i < laminas.length; i++) {
          laminas[i].classList.toggle('esta-activa', i === actual);
        }

        for (var j = 0; j < rotulos.length; j++) {
          rotulos[j].classList.toggle('esta-activa', j === actual);
        }

        for (var k = 0; k < paradas.length; k++) {
          var esActual = k === actual;
          paradas[k].classList.toggle('esta-activa', esActual);
          paradas[k].classList.toggle('esta-recorrida', k < actual);
          paradas[k].setAttribute('aria-selected', esActual ? 'true' : 'false');
          paradas[k].setAttribute('tabindex', esActual ? '0' : '-1');
        }

        if (relleno) {
          var porcentaje = total > 1 ? (actual / (total - 1)) * 100 : 0;
          relleno.style.width = porcentaje + '%';
        }

        if (contador) {
          var numero = actual + 1;
          contador.textContent = numero < 10 ? '0' + numero : String(numero);
        }

        programar();
      }

      for (var p = 0; p < paradas.length; p++) {
        (function (parada, indice) {
          parada.addEventListener('click', function () {
            mostrar(indice);
          });

          parada.addEventListener('keydown', function (evento) {
            if (evento.key !== 'ArrowLeft' && evento.key !== 'ArrowRight') return;
            evento.preventDefault();
            var siguiente = evento.key === 'ArrowRight' ? indice + 1 : indice - 1;
            if (siguiente < 0) siguiente = total - 1;
            if (siguiente >= total) siguiente = 0;
            mostrar(siguiente);
            paradas[siguiente].focus();
          });
        })(paradas[p], p);
      }

      escenario.addEventListener('mouseenter', function () {
        pausado = true;
        window.clearTimeout(temporizador);
      });

      escenario.addEventListener('mouseleave', function () {
        pausado = false;
        programar();
      });

      escenario.addEventListener('keydown', function (evento) {
        if (evento.key === 'ArrowLeft') mostrar(actual - 1);
        if (evento.key === 'ArrowRight') mostrar(actual + 1);
      });

      var inicioX = null;
      escenario.addEventListener('touchstart', function (evento) {
        inicioX = evento.touches[0].clientX;
        window.clearTimeout(temporizador);
      }, { passive: true });

      escenario.addEventListener('touchend', function (evento) {
        if (inicioX === null) return;
        var recorrido = evento.changedTouches[0].clientX - inicioX;
        if (Math.abs(recorrido) > 46) {
          mostrar(actual + (recorrido < 0 ? 1 : -1));
        } else {
          programar();
        }
        inicioX = null;
      }, { passive: true });

      if ('IntersectionObserver' in window) {
        var arranque = new IntersectionObserver(function (entradas) {
          for (var a = 0; a < entradas.length; a++) {
            if (entradas[a].isIntersecting && !arrancado) {
              arrancado = true;
              programar();
              arranque.disconnect();
            }
          }
        }, { threshold: 0.3 });
        arranque.observe(escenario);
      } else {
        programar();
      }
    }

    function iniciarTodas(contexto) {
      var ambito = contexto || document;
      var secciones = ambito.querySelectorAll('[data-viaje-sc]');
      for (var i = 0; i < secciones.length; i++) {
        iniciarViaje(secciones[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        iniciarTodas();
      });
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      iniciarTodas(evento.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
